import withIcon from './NewIcon';
// @ts-ignore
import IconReviews from './icon/xl/reviews.s.svg';

export default withIcon(IconReviews);
